var mapControllers = angular.module('mapControllers', []);

mapControllers.controller('ListController', ['$scope', '$http', '$sce', function($scope, $http, $sce) {
	$(window).scrollTop(0);
	var mapCards = [];

	window._listController = $scope;

	// array sort by object property
	function arrayObjectPropSort(prop){
		return function(a, b){
			var propA = typeof a[prop] == 'string' ? a[prop].toUpperCase() : a[prop],
					propB = typeof b[prop] == 'string' ? b[prop].toUpperCase() : b[prop];

			if (propA < propB) {
				return -1;
			}
			if (propA > propB) {
				return 1;
			}
			return 0;
		}
	}

	// search filter data
	$scope.filterOptions = {
		stores:[]
	};

	$scope.sortOptions = {
		stores: []
	};
	// add top items after sorting below
	var topFilterOption = {
		id : 0,
		name : 'All Themes',
		rating: 0
	}
	var topSortOption = {
		id : -1,
		themeId:0,
		name : 'All Sub Themes',
		rating: 0
	}

	window._dev_data = data;

	var replaceImageUrlParts = [
		{
			findValue: /aem-author-prd\.esri\.com/,
			replaceValue:"www.esri.com"	
		},
		{
			findValue: /http:\/\//,
			replaceValue:"https://"	
		}
	]
	if(true){
		data.forEach(function(dataItem) {
				
			for(i=0 ; i<replaceImageUrlParts.length ; i++){
				dataItem.banner = dataItem.banner.replace(replaceImageUrlParts[i].findValue,replaceImageUrlParts[i].replaceValue)
			}
				
			for(var j=0 ; j<dataItem.mapcard.length ; j++){
				var mapcardItem = dataItem.mapcard[j];
				for(ii=0 ; ii<replaceImageUrlParts.length ; ii++){
					mapcardItem.thumb = mapcardItem.thumb.replace(replaceImageUrlParts[ii].findValue,replaceImageUrlParts[ii].replaceValue)
				}

				for(var jj=0; jj<mapcardItem.gallery.length ; jj++){
						for(iii=0 ; iii<replaceImageUrlParts.length ; iii++){
							mapcardItem.gallery[jj] = mapcardItem.gallery[jj].replace(replaceImageUrlParts[iii].findValue,replaceImageUrlParts[iii].replaceValue)
						}
				}
			}
		})
	}

	data.forEach(function(item) {
		var mCards = item.mapcard.map(function(mCard) {
			mCard.id = item.id;
			mCard.icon = item.icon;
			mCard.banner = item.banner;
			mCard.color = item.color;
			mCard.theme = item.theme;
			mCard.index = item.mapcard.indexOf(mCard);
			return mCard;
		});
		mapCards = mapCards.concat(mCards);
		$scope.filterOptions.stores.push(
			{
				id: item.id,
				name: item.theme,
				introduction: item.themeIntro ? item.themeIntro : "",
				rating: item.id
			});
		item.mapcard.forEach(function(card) {
			if(card.subtheme != "" && $scope.sortOptions.stores.find(function(item){ return card.subtheme == item.name }) == undefined){
				$scope.sortOptions.stores.push(
					{
						id: $scope.sortOptions.stores.length,
						themeId: item.id,
						name: card.subtheme,
						introduction: item.subthemeIntro ? item.subthemeIntro[card.subtheme] : "null",
						rating: $scope.sortOptions.stores.length
					}
				)
			}
		});
	});

	$scope.filterOptions.stores.sort(arrayObjectPropSort('name'))
	$scope.filterOptions.stores.unshift(topFilterOption)
	$scope.sortOptions.stores.sort(arrayObjectPropSort('name'))
	$scope.sortOptions.stores.unshift(topSortOption)

	window._dev_sortOptions = $scope.sortOptions
	window._dev_filterOptions = $scope.filterOptions

	$scope.maps = mapCards;
	$scope.artistOrder = 'name';

	$scope.clearAll = function() {
		//Mapped to the model to filter
		$scope.filterItem = {
			store: $scope.filterOptions.stores[0]
		}
		showHideThemeIntro($scope.filterOptions.stores[0])
		
		//Mapped to the model to sort
		$scope.sortItem = {
			store: $scope.sortOptions.stores[0]
		};
	}

	$scope.clearAll();

	//Theme filter - filter based on the theme selected
	$scope.themeFilter = function (data) {
		if ($scope.filterItem.store.rating === 0) {
			return true;
		}
		return data.id === $scope.filterItem.store.rating;
	};
	//Industry filter - filter based on the industry selected
	$scope.industryFilter = function (data) {
		if($scope.sortItem.store.id == -1) {
			return true;
		}
		return data.subtheme === $scope.sortItem.store.name;
	};

	$scope.onThemeChange = function _lc_onThemeChange(){
		// if theme not "All Themes"
		$scope.trackActivity(
			{
				activity:"select theme '"+$scope.filterItem.store.name+"', id="+$scope.filterItem.store.id,
				subActivity:""
			}
		)

		if($scope.filterItem.store != $scope.filterOptions.stores[0]){
			// if industry/subtheme not in theme
			if($scope.sortItem.store.themeId != $scope.filterItem.store.id) {
				$scope.sortItem.store = $scope.sortOptions.stores[0];
			}
		}
		else{
			$scope.sortItem.store = $scope.sortOptions.stores[0];
		}
		showHideThemeIntro($scope.filterItem.store)
	}

	$scope.onSubThemeChange = function _lc_onSubthemeChange(){
		var themeItem = $scope.filterItem.store;

		$scope.trackActivity(
			{
				activity:"select subtheme '"+$scope.sortItem.store.name+"', id="+$scope.sortItem.store.id,
				subActivity:""
			}
		)

		if($scope.sortItem.store != $scope.sortOptions.stores[0]){
			$scope.filterItem.store = $scope.filterOptions.stores.filter(function(themeItem){
				return themeItem.id == $scope.sortItem.store.themeId;
			})[0]
		}
		else{
		//	$scope.filterItem.store = $scope.filterOptions.stores[0]
		}
		showHideThemeIntro($scope.filterItem.store)
	}
	
	function showHideThemeIntro(store){
		if(!!document.querySelector(".list-theme-intro")){
			var theme = document.querySelector(".list-theme-intro");
			var wrap = document.querySelector(".theme-subtheme-click-box-wrapper");

			if(store.introduction){
				theme.style.height = "auto"; // "180px";
				theme.style.paddingBottom = "60px"; // "180px";
				theme.style.opacity = 1;
				wrap.style.opacity = 1;
			}
			else{
				theme.style.height = 0;
				theme.style.paddingBottom = 0;
				theme.style.opacity = 0;
				wrap.style.opacity = 0;
			}
		}
	}

	$scope.modalIntroHeading = "heading";
	$scope.modalIntroText = "text body";

	function bodyScrollOn(){
		document.querySelector("body").classList.remove("body-no-scroll");
		var top = document.querySelector(".theme-filter-wrapper").offsetTop - 60;
		window.scroll(0, top)
	}
		
	function bodyScrollOff(){
		document.querySelector("body").classList.add("body-no-scroll");
	}

	$scope.modalWindowClose = function  _lc_modalWindowClose(event){
		if(event.target.className.match(/modal-window-background|modal-window-close/)){
			bodyScrollOn();
			document.querySelector(".modal-window-background").style.opacity = 0;
			setTimeout(function(){
				document.querySelector(".modal-window-background").style.zIndex = -1;
				$scope.modalIntroHeading = "";
				$scope.modalIntroText = "";
			},400)
		}
	}

	$scope.showThemeIntroModal = function  _lc_showThemeIntroModal(){
		$scope.modalIntroHeading = $scope.filterItem.store.name;
		$scope.modalIntroText = $scope.filterItem.store.introduction;
		$scope.trackActivity(
			{
				activity:"open theme intro '"+$scope.filterItem.store.name+"', id="+$scope.filterItem.store.id,
				subActivity:""
			}
		)

		bodyScrollOff();
		document.querySelector(".modal-window-background").style.zIndex = 90;
		document.querySelector(".modal-window-background").style.opacity = 1;
	}

	$scope.showSubthemeIntroModal = function  _lc_showSubthemeIntroModal(){
		$scope.modalIntroHeading = $scope.sortItem.store.name;
		$scope.modalIntroText = $scope.sortItem.store.introduction;
		$scope.trackActivity(
			{
				activity:"open subtheme intro '"+$scope.sortItem.store.name+"', id="+$scope.sortItem.store.id,
				subActivity:""
			}
		)
		bodyScrollOff();
		document.querySelector(".modal-window-background").style.zIndex = 90;
		document.querySelector(".modal-window-background").style.opacity = 1;
	}

	$scope.learnMore = function _lc_learnMore(){
		alert('Introduction and Forward not available yet on test server.')
	}

	$scope.goToDetails = function _lc_goToDetails(map){
		var detailsHref = "#/details/"+map.id+"/"+map.index;
		$scope.trackActivity(
			{
				activity:"click to "+detailsHref,
				subActivity:""
			}
		)
	}

	$scope.goToForeword = function _lc_goToForeword(map){
		var forewordHref = "./foreword.html";
		$scope.trackActivity(
			{
				activity:"click to Foreword",
				subActivity:""
			}
		)
		setTimeout(function(){
			var forewardExists = !!([
				'webapps-cdn-dev.esri.com',
				'webapps-cdn.esri.com',
				'webapps-cdn-dev.esri.com',
				'localhost'
			].indexOf(location.hostname.toString()) === -1);

			if (forewardExists){
				window.location.href = forewordHref;
			} else {
				alert('The MapBook foreward is not available on this DEV/QA server.');
			}

		},10)
	}

	$scope.trackActivity = function _lc_analytics(obj){
		if (typeof _satellite === 'object') {
			 window.digitalData.appData.WebAppActivity = obj.activity || "";
			 window.digitalData.appData.WebSubAppActivity = obj.subActivity || "";
			 _satellite.track('MUWAT');
		}
	}

}]);








myApp.filter('subThemeFilter', [ function() {
	return function (options, scope) {
		// uncomment the following line to turn off filter
		return options;
		
		var array = [];
		if(scope.filterItem.store.id == 0){
			return options
		}
		else
		{
			options.forEach(function(e,i){
				if(e.themeId == scope.filterItem.store.id || e.themeId == 0){
					array.push(e)
				}
			})
		return array;
		}
	};
}]);






mapControllers.controller('DetailsController', ['$scope', '$http', '$routeParams','$sce', function($scope, $http, $routeParams, $sce) {
	$(window).scrollTop(0);
	$scope.maps = data;
	window._detialsController = $scope;
	var item = data.filter(function(item) {
		return item.id == $routeParams.itemId;
	});

	window._mapControllers = $scope;

	$scope.map = item[0];
	$scope.item = item[0].mapcard[$routeParams.index];

	$scope.showCourtesyOfLabel = function(){
		return $scope.item.courtesyof.toString().match(/courtesy/i) === null;
	}

	$scope.isPlural = function(prop){
		var testString = $scope.item[prop].toString()
			.replace(/,,/g,'')
			.replace(/;;/g,'')
			.replace(/&#\d\d+;/g,'')
			.replace(/&\w\w+;/g,'');
		
		var arr = testString.split(/[,;]/)
		if(prop === "Authors" && arr.length < 2){
			arr = testString.split(/ and /)
		}

		return (arr.length > 1)
	}


	$scope.item.showAuthors = $scope.item.Authors.toString().replace(/,,/g,',');
	$scope.item.showDataSources = $scope.item.DataSources.toString().replace(/,,/g,',').replace(/;;/g,';');


  // -------------------------
  // start $sce.trustAsHtml
  // -------------------------
  if((typeof $scope.item.title) == 'string') {
    $scope.item.title = $sce.trustAsHtml($scope.item.title);
  }



  if((typeof $scope.item.Authors) == 'string') {
    $scope.item.Authors = $sce.trustAsHtml($scope.item.Authors);
  }

  if((typeof $scope.item.Contact) == 'string') {
    $scope.item.Contact = $sce.trustAsHtml($scope.item.Contact);
  }
  if((typeof $scope.item.copyright) == 'string') {
    $scope.item.copyright = $sce.trustAsHtml($scope.item.copyright);
  }
  
  if((typeof $scope.item.courtesyof) == 'string') {
    $scope.item.courtesyof = $sce.trustAsHtml($scope.item.courtesyof);
  }

  if((typeof $scope.item.subtitle) == 'string') {
    $scope.item.subtitle = $sce.trustAsHtml($scope.item.subtitle);
  }
  if((typeof $scope.item.desc) == 'string') {
    $scope.item.desc = $sce.trustAsHtml($scope.item.desc);
  }
  if((typeof $scope.item.Software) == 'string') {
    $scope.item.Software = $sce.trustAsHtml($scope.item.Software);
  }
  if((typeof $scope.item.DataSources) == 'string') {
    $scope.item.DataSources = $sce.trustAsHtml($scope.item.DataSources);
  }
  // -------------------------
  // end $sce.trustAsHtml
  // -------------------------






	$scope.item.theme = item[0].theme; // (theme was present without this but lost durnig refresh)
	$scope.item.subthemeIntro = (function () {
		if(!item[0].subthemeIntro){
			return "";
		}
		else if(!item[0].subthemeIntro[$scope.item.subtheme]){
			return "";
		}
		else
		{
			return item[0].subthemeIntro[$scope.item.subtheme];
		}
	})();

	$scope.item.themeIntro = item[0].themeIntro || "";

	$scope.map.bannerClass = {
		"background": "url('"+$scope.map.banner+"')"
	}

	$scope.showModal = false;
	$scope.modalIntroHeading = "heading";
	$scope.modalIntroText = "text body";

	function bodyScrollOn(){
			document.querySelector("body").classList.remove("body-no-scroll");
			var top = document.querySelector(".theme-title").offsetTop - 70;
			window.scroll(0, top)
	}
		
	function bodyScrollOff(){
			document.querySelector("body").classList.add("body-no-scroll");
	}

	$scope.modalWindowClose = function  _lc_modalWindowClose(){
		if(event.target.className.match(/modal-window-background|modal-window-close/)){
			bodyScrollOn();
			document.querySelector(".modal-window-background").style.opacity = 0;
			setTimeout(function(){
				document.querySelector(".modal-window-background").style.zIndex = -1;
				$scope.modalIntroHeading = "";
				$scope.modalIntroText = "";
			},400)
		}
	}
	$scope.showThemeIntroModal = function  _lc_showThemeIntroModal(){
		$scope.modalIntroHeading = $scope.item.theme;
		$scope.modalIntroText = $scope.item.themeIntro;
		$scope.trackActivity(
			{
				activity:"open theme intro '"+$scope.item.theme+"'",
				subActivity:""
			}
		)
		bodyScrollOff();
		document.querySelector(".modal-window-background").style.zIndex = 90;
		document.querySelector(".modal-window-background").style.opacity = 1;
	}

	$scope.showSubthemeIntroModal = function  _lc_showSubthemeIntroModal(){
		$scope.modalIntroHeading = $scope.item.subtheme;
		$scope.modalIntroText = $scope.item.subthemeIntro;
		$scope.trackActivity(
			{
				activity:"open subtheme intro '"+$scope.item.subtheme+"'",
				subActivity:""
			}
		)
		bodyScrollOff();
		document.querySelector(".modal-window-background").style.zIndex = 90;
		document.querySelector(".modal-window-background").style.opacity = 1;
	}

	$scope.carouselOffset = 0;

	$scope.cantPageRight = function(dir) {
		return $scope.currentPage >= $scope.pageCount - 1 && dir == 1;
	}

	$scope.cantPageLeft = function(dir) {
		return $scope.currentPage == 0 && dir == -1;
	}

	$scope.advanceMoreItems = function(dir) {
		var itemWidth = $('.items-carousel .column-6').outerWidth();
		if($scope.cantPageLeft(dir) || $scope.cantPageRight(dir)) {
			return;
		}
		$scope.carouselOffset -= (dir * (itemWidth * 3));
		$scope.currentPage += dir;

		if($scope.currentPage == 0 ) $scope.carouselOffset = 0;	
		if($scope.currentPage == $scope.pageCount-1 && $scope.moreItems.length > 3) $scope.carouselOffset = (itemWidth * 3)-($scope.moreItems.length*itemWidth)
		if($scope.carouselOffset > 0 ) {
			$scope.carouselOffset = 0;	$scope.currentPage = 0;
		}
	}

	$scope.advanceMoreByPageIndex = function(index) {
		$scope.advanceMoreItems(index - $scope.currentPage)
	}

	$scope.advanceMoreReset = function() {		
		$scope.advanceMoreItems(0 - $scope.currentPage)
	}

	$scope.moreItems = item[0].mapcard.filter(function(mItem) {
		if(!!$scope.item.subtheme.length){
			return mItem != $scope.item && mItem.subtheme == $scope.item.subtheme;
		}
		else{
			return mItem != $scope.item
		}
	});

	$scope.moreItems.map(function(mItem){
		mItem.theme = item[0].theme
	})

	$scope.pageCount = Math.ceil($scope.moreItems.length / 3);
	$scope.currentPage = 0;

	$scope.showDetails = function(id, card) {

		var index = item[0].mapcard.indexOf(card);
		var url = window.location.href.split("#")[0] + "#/details/" + id + "/" + index;

		$scope.trackActivity(
			{
				activity:"click to #/details/"+id+"/"+index,
				subActivity:""
			}
		)

		window.location.href = url;
	}

	window.itemsCarouselColumnOneWidth = function _itemsCarouselColumnOneWidth(){
		
		var _ic = document.querySelector('.items-carousel')
		var _vp = document.querySelector('.view-pane')

		// first, set vp width according to ic 
		// then adjust inner .column6 width

		if(_ic && _vp){
			var _ic_style = window.getComputedStyle(_ic);
			var _vp_style = window.getComputedStyle(_vp);
			// set view-pain width
			_vp.style.width = (parseInt(_ic_style.width) - 125) + "px";
			//var showDiff = parseInt(_ic_style.width) - parseInt(_vp_style.width)
			var _w = parseInt(parseInt(_vp_style.width)/3);
			[].slice.call(_vp.querySelectorAll('.column-6')).forEach(function (el) {
				el.style="max-width:"+_w+"px;";
			})
		}
	}
	
	window.addEventListener('DOMContentLoaded',function(e){
		window.itemsCarouselColumnOneWidth()
	})

	window.addEventListener('resize',function(e){
		window.itemsCarouselColumnOneWidth();
	})

	setTimeout(function(){
		window.itemsCarouselColumnOneWidth();
	},500)


	$scope.goToList = function _lc_goToList(item){
		$scope.trackActivity(
			{
				activity:"click to #/list",
				subActivity:""
			}
		)
		window.location.href = window.location.href.split("#")[0] + "#/list";
	}
	
	$scope.trackActivity = function _dc_analytics(obj){
		if (typeof _satellite === 'object') {
			 window.digitalData.appData.WebAppActivity = obj.activity || "";
			 window.digitalData.appData.WebSubAppActivity = obj.subActivity || "";
			 _satellite.track('MUWAT');
		}
	}
		
}]);